import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../configureStore";
import axios from "axios";

import { API } from "../../../config";
import {
  fetchLocationsWithActivity,
  managingUndefined,
} from "../map/mapAsyncActions";

import {
  setLocationGrainTracker,
  setValuesEditLocation,
} from "../../slices/grainTracker/grainTrackerEdition";

import { fetchStoragesOfEachLocation } from "../GrainWise/grainwiseEditionServices/grainTrackerGetServicesEdition";
import { fetchLocationMapbox } from "../GrainWise/grainTrackerGetServices";

export const fetchLocationMapboxCoordinatesEditLoc = createAsyncThunk(
  "EditLocationSlice/fetchLocationMapboxCoordinatesEditLoc",
  async (arg: { longitude: number; latitude: number }, store) => {
    const { selectedLocation } = (store.getState() as RootState)
      .GrainWiseEditionReducer;

    const { locale } = (store.getState() as RootState).LayoutReducer;

    try {
      const response = await axios.get(
        `https://api.mapbox.com/search/geocode/v6/reverse?longitude=${arg.longitude}&latitude=${arg.latitude}&access_token=${process.env.REACT_APP_MAPBOX_TOKEN}`,
        {
          headers: {
            "Accept-Language": `${locale}`,
          },
        },
      );
      const { data } = response;
      const values = data.features[0];
      if (values) {
        store.dispatch(
          setValuesEditLocation({
            ...selectedLocation,
            values: {
              ...selectedLocation.values,
              address: values.properties.full_address,
              countryName: values.properties.context.country.name,
              longitude: values.properties.coordinates.longitude,
              latitude: values.properties.coordinates.latitude,
            },
            error: "",
          }),
        );
      } else {
        store.dispatch(
          setValuesEditLocation({
            ...selectedLocation,
            values: {
              ...selectedLocation.values,
              address: "",
              countryName: "unknown",
              longitude: "",
              latitude: "",
            },
            locationValidate: false,
          }),
        );
      }
    } catch (error: any) {
      store.dispatch(
        setValuesEditLocation({
          ...selectedLocation,
          values: {
            ...selectedLocation.values,
            address: "",
            countryName: "unknown",
            longitude: "",
            latitude: "",
          },
          error: error.response.data.message,
          locationValidate: false,
        }),
      );

      store.rejectWithValue(error.response.data.message);
    }
  },
);

export const updateLocation = createAsyncThunk(
  "EditLocationSlice/updateLocation",
  async (arg: { token: string; navigate: any }, store) => {
    const { locale } = (store.getState() as RootState).LayoutReducer;
    const { locationGrainTrackerValues, locationSelectedIs, selectedLocation } =
      (store.getState() as RootState).GrainWiseEditionReducer;

    const { name, latitude, longitude, id } = selectedLocation.values;

    const headers = {
      "Accept-Language": `${locale}`,
      Authorization: `Bearer ${arg.token}`,
    };
    const address = await fetchLocationMapbox(
      arg.token,
      locale,
      parseFloat(longitude as any),
      parseFloat(latitude as any),
    );

    store.dispatch(
      setValuesEditLocation({ ...selectedLocation, loading: true, error: "" }),
    );
    if (address.properties.context.country.name) {
      try {
        const response = await axios.patch(
          `${API}/users/organization-geo-point/${id}`,
          {
            name: managingUndefined(name),
            latitude: managingUndefined(parseFloat(latitude as any)),
            longitude: managingUndefined(parseFloat(longitude as any)),
            address: managingUndefined(
              address.properties.full_address as string,
            ),
            altitude: 0,
            countryName: managingUndefined(
              address.properties.context.country.name as string,
            ),
          },
          { headers },
        );

        const { data } = response;

        store.dispatch(
          setValuesEditLocation({
            ...selectedLocation,
            loading: false,
            isSuccessEdited: true,
            error: "",
          }),
        );

        if (
          data &&
          !locationSelectedIs.EditingStockage &&
          locationSelectedIs.EditingValues
        ) {
          arg.navigate(`/site/details/${data.name}`);
        }

        if (
          data &&
          locationSelectedIs.EditingStockage &&
          locationSelectedIs.EditingValues
        ) {
          store.dispatch(
            setLocationGrainTracker({
              ...locationGrainTrackerValues,
              loading: false,
              locationInformation: data,
              error: "",
            }),
          );
          store.dispatch(
            fetchStoragesOfEachLocation({
              token: arg.token,
              orgGeoPointId: data.id,
            }),
          );
          store.dispatch(fetchLocationsWithActivity());
          arg.navigate(`/site/edit/storage/${data.name}`);
        }

        store.fulfillWithValue("success");
      } catch (error: any) {
        store.dispatch(
          setValuesEditLocation({
            ...selectedLocation,
            loading: false,
            error: error.response.data.message,
          }),
        );
        return store.rejectWithValue(error);
      }
    } else {
      return store.rejectWithValue("not a valid country name");
    }
  },
);
